import { ENDPOINTS } from './endpoints'
import { http } from './http'
import type { ApiResponse } from './http/types'

export interface MerchantSummaryData {
  products_count: number
}

export type DashboardCompletionStepKey =
  | 'complete_onboarding'
  | 'subscribe_to_plan'
  | 'choose_theme'
  | 'launch_store'
  | 'add_first_product'
  | 'add_first_shipping_method'
  | 'configure_payment'
  | 'preview_store'

export interface DashboardCompletionStep {
  key: DashboardCompletionStepKey
  label: string
  complete: boolean
  blockers: string[]
}

export interface DashboardCompletion {
  completed_steps: number
  total_steps: number
  percentage: number
  next_step: { key: DashboardCompletionStepKey; label: string } | null
  steps: DashboardCompletionStep[]
}

export interface DashboardStats {
  products_count: number
  orders_count: number
  customers_count: number
  stores_count: number
  store_views: number
}

export interface AiDashboardCompletion {
  percentage: number
  done_steps: string[]
  next_steps: { key: DashboardCompletionStepKey; label: string; complete: boolean }[]
}

export interface MerchantDashboardStore {
  id: string
  name: string
  subdomain: string
  status: string
  plan?: string
  theme_id: string | null
}

export interface MerchantDashboardData {
  mode: 'dashboard' | 'onboarding_required'
  store?: MerchantDashboardStore | null
  completion?: DashboardCompletion
  ai_completion?: AiDashboardCompletion
  preview?: { mode: 'preview' | 'live'; open_endpoint: string }
  stats?: DashboardStats
}

export interface StorefrontOpenData {
  mode: 'preview' | 'live'
  url: string
}

export const merchantService = {
  getSummary: () =>
    http.get<ApiResponse<MerchantSummaryData>>(ENDPOINTS.merchantSummary),

  getDashboard: () =>
    http.get<ApiResponse<MerchantDashboardData>>(ENDPOINTS.merchantDashboard.base),

  openStorefront: () =>
    http.post<ApiResponse<StorefrontOpenData>>(ENDPOINTS.merchantDashboard.storefrontOpen),

  launchStore: () =>
    http.post<ApiResponse<{ store_id: string; status: string }>>(ENDPOINTS.merchantDashboard.launch),
}
